import { DataLayer } from "@grandvisionhq/analytics";
const siteFeature = "newsletter_subscription";
const pushNewsletterEvent = (event) => {
  DataLayer.pushEvent({
    event: event.eventName ?? "",
    site_feature: siteFeature,
    interaction_type: event.interactionType,
    ...event.optionClicked ? { option_clicked: event.optionClicked } : null
  });
};
export {
  pushNewsletterEvent,
  siteFeature
};
//# sourceMappingURL=newsletter.js.map
